import React from 'react';
import { Input } from 'antd';
import { AreaSelect } from './area-select.js';
import { usePhoneInput } from './shared.js';
import { PhoneInputStyles } from './phone-input-styles.js';

const CountryPhoneInput = ({ defaultValue, onChange, selectProps = {}, inputGroupProps, inline, className, disabled, ...inputProps }) => {
    const isControlled = 'value' in inputProps;
    const { value } = inputProps;
    const { area, handleAreaChange, handlePhoneChange } = usePhoneInput({
        isControlled,
        defaultValue,
        value,
        onChange,
    });
    const commonProps = { disabled };
    React.createElement(AreaSelect, { ...commonProps, ...selectProps, value: area?.short, onChange: handleAreaChange });
    // if (inline) {
    //   inputProps.addonBefore = areaSelect;
    // } else {
    //   inputProps.prefix = areaSelect;
    // }
    return (React.createElement(PhoneInputStyles, null,
        React.createElement(Input, { addonBefore: React.createElement(AreaSelect, { ...commonProps, ...selectProps, value: area?.short, onChange: handleAreaChange }), ...commonProps, ...inputProps, className: 'antd-country-phone-input' + (className ? ` ${className}` : ''), value: value?.phone, onChange: handlePhoneChange })));
};

export { CountryPhoneInput };
